




























































import { mapGetters } from 'vuex'
import Vue from 'vue'
import Invitation from '@/types/Invitation.interface'
import VerificationForm from './VerificationForm.vue'
export default Vue.extend({
    components: { VerificationForm },
    data() {
        return {
            invitation: {
                email: null,
                selectedRole: null
            },
            loading: false
        }
    },
    computed: {
        ...mapGetters(['invitations', 'user', 'roles']),
        formIncomplete(): boolean {
            return this.invitation.email == null || this.invitation.selectedRole == null
        },
        invitationCount(): number {
            //  If no invitations, return 0
            if (!this.invitations) return 0

            //  Else count the total that aren't snapdesk/messagedesk/support
            return this.invitations.filter(
                (x: Invitation) =>
                    x.role_id !== 5 &&
                    !x.email.includes('@snapdesk.app') &&
                    !x.email.includes('@messagedesk.com')
            ).length
        },
        userCount(): number {
            return this.$store.getters.userCount
        },
        userLimit(): number {
            //  Grab our total number of users from our stripe plan
            return this.$store.getters.getLimit('user')
        },
        userLimitReached(): boolean {
            return this.userCount >= this.userLimit
        },
        userPrice(): string {
            //  Get the current product tier
            const tier = this.$store.getters.productTier

            //  If the tier is Team then return 15
            if (tier === 'Team') return '$15/mo'

            //  Else, return 10
            return '$10/mo'
        }
    },
    methods: {
        async invitationsPost(invitation: Invitation): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Send the request to the API
            const response = await this.$store.dispatch('invitationSend', invitation)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Else, close app dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Notify user of success
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Teammate Invited',
                text: `${invitation.email} has been emailed an invite to join your MessageDesk account.\n\nManage this invitation by clicking on the teammate from the Team Module.`,
                icon: 'bi-check-circle-fill',
                color: 'primary',
                closeable: true
            })
        },
        popRoleHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Teammate Permissions Explained',
                text: `MessageDesk supports 3 levels of permission: Admin, Manager, Operator.\n\n<b>Admin</b>: the creator of your MessageDesk account. This person has access to everything and is the only person who can update the account’s subscription. Each account can only have 1 Admin. To change this admin, please email support@messagedesk.com.\n\n<b>Manager</b>: Has the same level of feature access as the Admin but is not the point of contact for the account. They are prevented from updating the account’s phone number or payment details. This is great for teammates who need all-access to the platform.\n\n<b>Operator</b>: Has limited access to MessageDesk features. They are unable to delete existing contacts, create or edit SMS campaigns, and unable to upload contact data in bulk via CSV uploads. This is great for teammates who may need to send a Broadcast, manage the inbox or need to export information from MessageDesk.`,
                icon: 'bi-question-circle-fill',
                color: '#717171',
                closeable: true,
                width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '400px'
            })
        },
        async submit(): Promise<void> {
            //  Validate our inputs
            const valid = await this.$validator.validateAll()

            //  If invalid, do nothing
            if (!valid) return

            //  Else, send invite
            this.invitationsPost(this.invitation)
        }
    }
})
